module.exports = __webpack_public_path__ + "img/search_active.95dcf01b.svg";